exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".container[data-v-7cb2576e]{background-color:#fbfafa;font-size:1.6rem;line-height:1.4;font-family:Open Sans;color:#333;margin:0 auto;padding:0;width:100%;max-width:600px;position:relative}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7cb2576e","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Layout.vue
// module id = 644
// module chunks = 0